export const PhoneInputStyles = {
  field:
    'appearance-none text-16px border border-gray60 rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline',
}
